// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d551405a","239":"c36b8fab","453":"b3b180e5","732":"8ed4787a"}[chunkId] + ".chunk.js";
};